<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">宣传公告名称：</span>
        <el-input v-model="search.noticeName" :size="size" clearable placeholder="请输入宣传公告名称"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">上架时间：</span>
        <el-date-picker
            v-model="search.time"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00','23:59:59']"
            start-placeholder="起始时间"
            end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="noticeName" label="宣传公告名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="orderBy" label="排序" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="paths" label="轮播图" align="center">
            <template #default="{row}">
                <div>
                    <el-image
                        style="width:50px;height:50px; cursor: pointer;"
                        :src="`https://htpipe.thhy-tj.com/${row.paths[0]}`"
                        :preview-src-list="showImgLists(row)"
                        fit="contain">
                        <div slot="error" class="image-slot">
                          <img src="https://htpipe.thhy-tj.com/group1/M00/00/03/bx5d1GRlfmCAEmAPAAAFoOEW2dU397.png" style="width:50px;height:50px">
                        </div>
                    </el-image>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="createTime" label="上架时间" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="下架时间" align="center"></el-table-column>
        <el-table-column prop="states" label="公告状态" align="center">
            <template #default="{row}">
                <div>{{row.states === 1 ?'上架':row.states === 2 ?'下架':''}}</div>
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="400">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
            <el-button class="table_btn" size="mini" v-if="row.states === 2 && showButton('grounding')" @click="putAway(row)">上架</el-button>
            <el-button class="table_btn" size="mini" v-if="row.states === 1 && showButton('grounding')" @click="putAway(row)">下架</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('preview')" @click="previewInfo(row)">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增宣传公告' : '修改宣传公告'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="75%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="宣传公告名称：" prop="noticeName">
          <el-input v-model="ruleForm.noticeName" :size="size" clearable placeholder="请输入宣传公告名称"></el-input>
        </el-form-item>
        <el-form-item label="排序：" prop="orderBy">
          <el-input v-model="ruleForm.orderBy" :size="size" clearable placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item label="轮播图：" prop="station">
          <upload-image :file-list="imageList"  @delectImage="delectImage">
            <template #info>
                <span>支持jpg、png、gif格式文件</span>
            </template>
          </upload-image>
        </el-form-item>
        <el-form-item label="公告内容：" prop="noticeContent">
          <edit-forms @editorCreate="editorCreate" :editorShow="ruleForm.noticeContent" v-if="asyncVisible"></edit-forms>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 预览按钮 -->
    <el-dialog
        class="preview_dialog"
        :close-on-click-modal="false"
        :visible.sync="previewVisible"
        :fullscreen="true"
        width="100%">
        <div class="preview_content">
            <div class="preview_titles">{{previewTitle}}</div>
            <div class="preview_times">{{previewTime}}</div>
            <div v-html="previewContent" class="preview_main"></div>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize,changeTime } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
import UploadImage from '../../components/uploadImage.vue'
import EditForms from '@/components/EditForms.vue'
  export default {
    components:{
       UploadImage,
       EditForms
    },
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //标段信息列
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {}, // 按钮表单
        rules: {
          noticeName: [{
            required: true,
            message: '请输入宣传公告名称',
            trigger: 'blur'
          }],
          noticeContent: [{
            required: false,
            message: '请输入公告内容',
            trigger: 'blur'
          }],
        },
        imageList:[],//上传图片
        editor:null,//富文本实例
        previewVisible:false,//预览弹框
        previewContent:"",//预览内容
        previewTitle:"",//预览内容标题
        previewTime:"",//预览中的时间
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.imageList = []
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true)
    },
    methods: {
      //处理照片数组
      showImgLists(val){
        let imgList = [] 
        val.paths.map(item=>{
            imgList.push(`https://htpipe.thhy-tj.com/${item}`)
        })
        return imgList
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          noticeType:1
        })
        params.strTime = this.search.time&&this.search.time[0]
        params.endTime = this.search.time&&this.search.time[1]
        delete params.time
        this.loading = true;
        this.$api.Notice.searchNotices(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }else{
            this.$message.warning(res.statusMsg)
          }
          this.loading = false;
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
        this.ruleForm.noticeContent = null
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.$api.Notice.detailsNotices({noticeId: row.noticeId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
                res.data.paths.map(item=>{
                    this.imageList.push({
                        id: this.imageList.length + 1,
                        url:`https://htpipe.thhy-tj.com/${item}`,
                        name:item
                    })
                })
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Notice.deleteNotices({noticeId: row.noticeId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.noticeType = 1
            let arrTitle = []
            this.imageList.forEach(item=>{
                arrTitle.push(item.name)
            })
            params.pictureList = arrTitle
            params.noticeContent = this.editor.getHtml()
            if(this.editor.getText().length>5000){
              this.$message.warning('文本框中的字数超过了5000！！！')
              return false
            }else{
              this.$api.Notice.insertNotices(params).then((res) => {
                if(res.statusMsg === 'ok') {
                  this.asyncVisible = false;
                  this.searchButtonInfo(true);
                  this.$message.success('添加成功！');
                } else {
                  this.$message.warning(res.data);
                }
              })
            }
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.noticeType = 1
            let arrTitle = []
            this.imageList.forEach(item=>{
                arrTitle.push(item.name)
            })
            params.pictureList = arrTitle
            params.noticeContent = this.editor.getHtml()
            if(this.editor.getText().length>5000){
              this.$message.warning('文本框中的字数超过了5000！！！')
              return false
            }else{
              this.$api.Notice.updateNotices(params).then((res) => {
                if(res.statusMsg === 'ok') {
                  this.asyncVisible = false;
                  this.searchButtonInfo(true);
                  this.$message.success('修改成功！');
                } else {
                  this.$message.warning(res.data);
                }
              })
            }
          }
        })
      }, 3000),
      //上架按钮
      putAway(val){
        if(val.states === 1){//点击下架
            this.$api.Notice.putDownNotices({noticeId:val.noticeId,states:2,updateTime:changeTime(Date.now())}).then(res=>{
                if(res.statusMsg === 'ok'){
                    this.$message.success(res.data)
                    this.searchButtonInfo(true);
                }else{
                    this.$message.warning(res.statusMsg)
                }
            })
        }else{//点击上架
            this.$api.Notice.putDownNotices({noticeId:val.noticeId,states:1}).then(res=>{
                if(res.statusMsg === 'ok'){
                    this.$message.success(res.data)
                    this.searchButtonInfo(true);
                }else{
                    this.$message.warning(res.statusMsg)
                }
            })
        }
      },
      //预览按钮
      previewInfo(item){
        this.previewVisible = true
        this.previewTitle = item.noticeName
        this.previewTime = item.createTime
        this.previewContent = item.noticeContent
      },
      //删除上传图片
      delectImage(item){
        let uploadId = item.id
        this.imageList.splice(this.imageList.findIndex(itm => itm.id === uploadId),1)
        this.$message.success("删除成功!")
      },
      //富文本返回结果
      editorCreate(editors){
        this.editor = editors
        // console.log(editors,'富文本实例')
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
</style>